const contentCookie = () => import("@/pages/content/cookie/index.vue");

export default [
    {
        path: "/content/cookie",
        component: contentCookie,
        meta: [
            {
                name: "内容管理",
                activeRoute: "/content/manage",
            },
            {
                name: "cookie政策",
                activeRoute: "/content/cookie",
            },
        ],
    },
];
